/** SG PreSet — AGM with Audited Financial Statements (7 documents). */
export const SG_AGM_AFS_TASK_CODE = 'B32204';

/** SG PreSet — AGM with Unaudited Financial Statements. */
export const SG_AGM_UFS_TASK_CODE = 'B32201';

/** SG PreSet — AGM Exempted with Audited Financial Statements. */
export const SG_AGM_EXEMPTED_AFS_TASK_CODE = 'B32202';

/** SG PreSet — AGM Exempted with Unaudited Financial Statements. */
export const SG_AGM_EXEMPTED_UFS_TASK_CODE = 'B32203';
